module.exports = __webpack_public_path__ + "static/img/dayed.b64ce798.png";